@import 'styles/variables';
@import 'styles/mixins';
@import 'styles/blaze/mixins';

.root {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 60px;
  min-width: 60px;
  gap: 7px;

  .title {
    color: var(--dark-40);
    font-family: Sohne;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 127%;
    letter-spacing: 0.24px;

    [data-autopilot-system-redesign='on'] & {
      font-weight: 400;
    }
  }

  .buttons {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;

    .platformButton {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 34px;
      height: 34px;
      border-radius: 6px;
      background-color: var(--dark-4);
      cursor: pointer;

      &:hover {
        background: var(--dark-8);
      }

      &.active {
        border: 2px solid var(--selected-fill);
        background: var(--light-80);

        [data-autopilot-system-redesign='on'] & {
          border: 1px solid var(--selected-fill);
          background: var(--light-100);
        }
      }

      &.redesignButton {
        background-color: transparent;
        width: auto;
        height: auto;
        padding: 4px;
        border: 1px solid var(--dark-4);

        &:hover {
          background-color: transparent;
          border-color: var(--dark-8);
        }

        &.active {
          border: 1px solid var(--dark-90);
          background: transparent;
        }
      }

      &.hideButton {
        height: 30px;

        svg {
          margin-top: -1px;
        }
      }
    }
  }

  &.redesign {
    gap: 10px;
    margin-right: 5px;

    .title {
      font-size: 14px;
    }

    .buttons {
      gap: 8px;
      align-items: flex-start;
    }
  }
}
